module.exports = __webpack_public_path__ + "img/diners.71c1866f.png";